import PropTypes from 'prop-types';
import { MoreHorizontal } from 'lucide-react';

import { Button } from '#/modules/commonComponents/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '#/modules/commonComponents/dropdown-menu';

const TableRowActionsMenu = ({ actions = [] }) => {
  if (!actions.length) {
    return null;
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="h-8 w-8"
          aria-label="列操作"
          onClick={(event) => event.stopPropagation()}
          onMouseDown={(event) => event.stopPropagation()}
        >
          <MoreHorizontal size={16} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(event) => event.stopPropagation()}>
        {actions.map((action) => (
          <DropdownMenuItem
            key={action.key || action.label}
            variant={action.destructive ? 'destructive' : 'default'}
            disabled={action.disabled}
            onClick={(event) => {
              event.stopPropagation();
              if (action.onClick) {
                action.onClick();
              }
            }}
          >
            {action.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

TableRowActionsMenu.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      disabled: PropTypes.bool,
      destructive: PropTypes.bool,
    })
  ),
};

export default TableRowActionsMenu;
